import FingerprintJS from '@fingerprintjs/fingerprintjs-pro';
const DEFAULT_TIMEOUT_MS = 1500;
const INTEGRATION_INFO = ['@v7/cx@login'];
const getFingerprintApiKey = () => {
    const apiKey = process.env.FINGERPRINT_API_KEY;
    if (!apiKey) {
        throw new Error('FINGERPRINT_API_KEY is not defined');
    }
    return apiKey;
};
const buildFingerprintEndpoints = () => {
    const endpoints = [];
    if (process.env.FINGERPRINT_ENDPOINT) {
        endpoints.push(process.env.FINGERPRINT_ENDPOINT);
    }
    if (FingerprintJS.defaultEndpoint) {
        endpoints.push(FingerprintJS.defaultEndpoint);
    }
    return endpoints;
};
const buildFingerprintScriptUrlPatterns = () => {
    const scriptUrlPatterns = [];
    if (process.env.FINGERPRINT_SCRIPT_URL_PATTERN) {
        scriptUrlPatterns.push(process.env.FINGERPRINT_SCRIPT_URL_PATTERN);
    }
    if (FingerprintJS.defaultScriptUrlPattern) {
        scriptUrlPatterns.push(FingerprintJS.defaultScriptUrlPattern);
    }
    return scriptUrlPatterns;
};
const getFingerprintRegion = () => process.env.FINGERPRINT_REGION;
export async function getFingerprintAgent() {
    if (typeof window === 'undefined') {
        throw new Error('FingerprintJS can only be used in a browser environment');
    }
    return FingerprintJS.load({
        apiKey: getFingerprintApiKey(),
        integrationInfo: INTEGRATION_INFO,
        endpoint: buildFingerprintEndpoints(),
        scriptUrlPattern: buildFingerprintScriptUrlPatterns(),
        region: getFingerprintRegion(),
    });
}
export async function fetchFingerprintResponse(options = {}) {
    const agent = await getFingerprintAgent();
    const agentOptions = {
        extendedResult: true,
    };
    if (options.metadata) {
        agentOptions.tag = options.metadata;
    }
    return (await agent.get(agentOptions));
}
export async function getFingerprintRequestId(options = {}) {
    const { timeoutMs = DEFAULT_TIMEOUT_MS, metadata } = options;
    if (typeof window === 'undefined') {
        return null;
    }
    const fingerprintPromise = fetchFingerprintResponse({ metadata })
        .then((response) => response.requestId ?? null)
        .catch(() => null);
    if (timeoutMs <= 0) {
        return fingerprintPromise;
    }
    return new Promise((resolve) => {
        const timer = window.setTimeout(() => resolve(null), timeoutMs);
        fingerprintPromise
            .then((requestId) => {
            window.clearTimeout(timer);
            resolve(requestId);
        })
            .catch(() => resolve(null));
    });
}
